import { types } from 'mobx-state-tree';

const AlternativePaymentMethodType = types.model('AlternativePaymentMethodType', {
  type: types.string,
  isAvailableOnPlatform: false, // Is the payment method available on the specific platform
  isAccepted: false, // Is the payment method accepted by adyen for this restaurant
});

export default AlternativePaymentMethodType;
